import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private loader = this.document.getElementById('hansel-loader');

  constructor(@Inject(DOCUMENT) private document: HTMLDocument) { }

  display(selector?, notScrollToTop?) {
    this.loader = document.querySelector(selector ? selector : '#hansel-loader');
    const scrollView = document.querySelector((selector && selector !== '#hansel-loader-full') ? selector : '.topmost-container');
    if (this.loader && scrollView) {
      if (!notScrollToTop) {
        scrollView.scrollIntoView();
      }
      this.disableScroll();
      this.loader.style.display = 'block';
    }
  }

  hide(selector?) {
    this.loader = document.querySelector(selector ? selector : '#hansel-loader');
    if (this.loader) {
      this.loader.style.display = 'none';
    }
    this.enableScroll();
  }

  preventDefault(e) {
    e = e || window.event;
    if (e.preventDefault) {
      e.preventDefault();
    }
    e.returnValue = false;
  }

  disableScroll() {
    if (window.addEventListener) {// older FF
      window.addEventListener('DOMMouseScroll', this.preventDefault, { passive: false });
    }
    document.addEventListener('wheel', this.preventDefault, { passive: false }); // Disable scrolling in Chrome

    window.onwheel = this.preventDefault; // modern standard
    // window.onmousewheel = document.onmousewheel = this.preventDefault; // older browsers, IE
    window.ontouchmove = this.preventDefault; // mobile
    document.onkeydown = this.preventDefault;
  }

  enableScroll() {
    if (window.removeEventListener) {
      window.removeEventListener('DOMMouseScroll', this.preventDefault, false);
    }
    document.removeEventListener('wheel', this.preventDefault, false); // Enable scrolling in Chrome

    // window.onmousewheel = document.onmousewheel = null;
    window.onwheel = null;
    window.ontouchmove = null;
    document.onkeydown = null;
  }
}
